import { SelMessage } from "@selector/shared/components";
import { type FC, Fragment } from "react";
import { useNavigate } from "react-router";
import { ActionButton, ActionButtonIconPlacement, ActionButtonIntent, ActionButtonSize, VStack } from "widgets";

import { pluralizeWord } from "../../app-utils/string.js";
import { JobStatusEnum, type Notification } from "../../graphql.js";
import { getJobPath } from "../../redux/modules/job.js";

export interface IJobNotificationProps {
  notification: Notification;
}

/**
 * A stateless component representing a job notification
 */
export const JobNotification: FC<IJobNotificationProps> = ({ notification }) => {
  const job = notification.playbookEvent?.job;
  const jobName = job?.tool?.toUpperCase() + " - " + job?.name;
  const navigate = useNavigate();

  return (
    <Fragment key={"job-notification-" + notification.id}>
      <VStack>
        <div>
          {job.status === JobStatusEnum.Error ? (
            <SelMessage id={"job.execution.failed"} values={{ jobName }} />
          ) : (
            <SelMessage id={"job.execution.statusUpdate"} values={{ jobName, status: job?.status?.toLowerCase() }} />
          )}
        </div>
        <div>
          <ActionButton
            label={job.status === JobStatusEnum.Completed ? pluralizeWord("Result", job.resultCount) : "Job Summary"}
            onPress={() => navigate(getJobPath(job))}
            intent={job.status === JobStatusEnum.Error ? ActionButtonIntent.Danger : ActionButtonIntent.Outlined}
            size={ActionButtonSize.Small}
            icon={"arrow_forward"}
            iconPlacement={ActionButtonIconPlacement.Right}
          />
        </div>
      </VStack>
    </Fragment>
  );
};
